module.exports = __webpack_public_path__ + "static/icon-3afca248c373d7132f019a5fae629d65.png";